<template>
  <div class="school-view">
    <!-- 院校列表 -->
    <div class="school-grid">
      <div class="school-card" v-for="(school, index) in visibleSchools" :key="index" @click="pickSchool(school)">
        <div class="school-name">{{ school.schoolname }}</div>
        <div class="school-count">留言数：{{ school.messagenum }}条</div>
        <img class="photo" :src="school.schoolpic1" :alt="school.schoolname">
      </div>
    </div>

    <!-- 查看更多/收起院校 -->
    <div class="more-schools" v-if="schools.length > pageSize">
      <div class="more-toggle" @click="showAll = !showAll">
        <template v-if="showAll">
          <div class="more-text">收起</div>
          <div class="more-line"></div>
          <img class="shouqi-icon" src="../assets/shouye/shouqi.png" alt="收起">
        </template>
        <img v-else class="more-img" src="../assets/shouye/more-schools.png" alt="查看更多院校">
      </div>
    </div>
  </div>
</template>

<script>
import { getSchoolList } from '@/api'

export default {
  name: 'SchoolGrid',
  data () {
    return {
      showAll: false,
      pageSize: 6,
      schools: []
    }
  },
  computed: {
    visibleSchools () {
      return this.showAll ? this.schools : this.schools.slice(0, this.pageSize)
    }
  },
  mounted () {
    this.getSchools()
  },
  methods: {
    getSchools () {
      getSchoolList().then(res => {
        var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
        if (data.code === 1) {
          this.schools = data.data
        }
      }).catch(() => {

      })
    },
    pickSchool (school) {
      this.$router.push({
        path: '/detail',
        query: {
          schoolid: school.schoolid,
          schoolname: school.schoolname,
          schoolpic2: school.schoolpic2,
          // schoolabst: school.schoolabst,
          xytj: school.xytj,
          xyzx: school.xyzx
        }
      })
    }
  }
}
</script>

<style scoped>
	.school-view{
		background-image: url(../assets/shouye/school-msg-box.png);
		background-size: 100% 100%;
		padding: 15px;
		margin: 0 5px;
	}
.school-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.school-card {
  width: 46.5%;
  background: url("../assets/shouye/school-card.png") no-repeat center / 100% 100%;
  padding: 14px 14px 16px;
  margin-bottom: 18px;
  text-align: center;
  cursor: pointer;
}

.school-name {
  font-size: 14px;
  font-weight: bold;
  color: #8a4a2a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.school-count {
  font-size: 12px;
  color: #b5764a;
  margin-top: 3px;
}

.school-card .photo {
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  margin-top: 10px;
}

.more-schools {
  display: flex;
  justify-content: center;
  margin: 2px 0 0px;
}

.more-toggle {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 35%;
  cursor: pointer;
}

.more-schools img {
  width: 35%;
}

.more-toggle .more-img {
  width: 100%;
}

.more-toggle .more-text {
  font-size: 18px;
  color: #8a4a2a;
}

.more-toggle .more-line {
  width: 100%;
  height: 1.5px;
  background: #8a4a2a;
  margin: 6px 0;
}

.more-toggle .shouqi-icon {
  width: 15%;
}


</style>
